export default __webpack_public_path__ + "static/media/calendarIcon-white.d963d807.svg";